import { atualUfDefinition } from "@/helpers/utils"

export function categorias() {

    if (atualUfDefinition.isSala) {
        return categoriasSelo
    }

    return categoriasCE
}


const categoriasCE = {
    indicador: "Indicadores",
    execucao: "Execução",
    territorio: "Territórios",
    recursos: "Recursos"

}

const categoriasSelo = {
    indicador: "Critérios",
    execucao: "Execução",
    territorio: "Territórios",
    recursos: "Recursos"


}